import { render, staticRenderFns } from "./letter-2.vue?vue&type=template&id=7abdb6c8&scoped=true"
import script from "./letter-2.vue?vue&type=script&lang=js"
export * from "./letter-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abdb6c8",
  null
  
)

export default component.exports